
export function validateIBAN(value: string): boolean {
    if (!value) return false;

    // Remove spaces and uppercase
    const iban = value.trim().toUpperCase().replace(/[^A-Z0-9]/g, '');

    // 1. Country code validation (first 2 characters must be letters)
    const countryCode = iban.substring(0, 2);
    if (!/^[A-Z]{2}$/.test(countryCode)) return false;

    // 2. Length validation
    // Define explicit lengths for specific countries as requested
    const countryLengths: { [key: string]: number } = {
        'NL': 18,
        'DE': 22,
        'FR': 27,
        'TR': 26,
        'BE': 16
    };

    // If country is in our list, check specific length
    if (Object.prototype.hasOwnProperty.call(countryLengths, countryCode)) {
        if (iban.length !== countryLengths[countryCode]) return false;
    } else {
        // Basic length check for other countries (min 15, max 34)
        if (iban.length < 15 || iban.length > 34) return false;
    }

    // 3. MOD-97 checksum is SKIPPED as per specific user request

    return true;
}
